import { z } from "zod";

export const getDriverMileageGapByCompanyResponseSchema = z.array(
  z.object({
    driverUuid: z.uuid(),
    vehicleUuids: z.array(z.uuid()),
    driverAnalyticCode: z.string(),
    date: z.iso.datetime(),
    mileageGap: z.number(),
    totalMileage: z.number(),
  }),
);

export type GetDriverMileageGapByCompanyResponse = z.infer<
  typeof getDriverMileageGapByCompanyResponseSchema
>;
